var init = require('init');

init.then(function (init) {
	const { postcodeValidator, postcodeValidatorExistsForCountry } = require('postcode-validator');
	// Import individual components here
	require('@material/layout-grid/mdc-layout-grid.scss');
	require('@material/elevation/mdc-elevation.scss');
	require('@material/textfield/mdc-text-field.scss');
	require('@material/select/mdc-select.scss');
	require('@material/linear-progress/mdc-linear-progress.scss');
	require('@material/chips/mdc-chips.scss');
	require('@material/tab-bar/mdc-tab-bar.scss');
	require('@material/tab-scroller/mdc-tab-scroller.scss');
	require('@material/tab-indicator/mdc-tab-indicator.scss');
	require('@material/tab/mdc-tab.scss');

	require('parsleyjs/src/parsley.css');

	require('@os/typography/typography.scss');
	require('@os/mdc/button.scss');
	require('@os/mdc/layout-grid.scss');
	require('@os/helper/helper.scss');
	require('@os/mdc/select.scss');
	require('@os/mdc/text-field.scss');
	require('@os/slider/mdc-slider.scss');

	require('../sass/parsleyjs/parsleyjs.scss');
	require('../sass/survey-header/survey-header.scss');
	require('../sass/header-menu-primary/header-menu-primary.scss');
	require('../sass/survey-step-list/survey-step-list.scss');
	require('../sass/survey-introduction/survey-introduction.scss');
	require('../sass/survey-step-1/survey-step-1.scss');
	require('../sass/survey-step-2/survey-step-2.scss');
	require('../sass/survey-step-3/survey-step-3.scss');
	require('../sass/plain-overlay/plain-overlay.scss');

	var introductionTemplate = require('../view/survey-introduction.hbs');
	var step1Template = require('../view/survey-step-1.hbs');
	var step2Template = require('../view/survey-step-2.hbs');
	var step3Template = require('../view/survey-step-3.hbs');
	var phoneWidgetTemplate = require('../view/phone-widget.hbs');
	var extranetAuthTemplate = require('../view/extranet-auth.hbs');

	define(['jquery',
		'i18next',
		'@os/header',
		'@os/footer',
		'@os/query-string',
		'@material/textfield',
		'@material/select',
		'@material/chips',
		'@material/tab-indicator',
		'@material/tab',
		'parsleyjs',
		'@os/phone-widget',
		'@os/form-data',
		'js-cookie',
		'moment',
		'@material/slider',
		'@material/dialog'
	], function ($, i18next, header, footer, queryString, mdcTextField, mdcSelect, mdcChips, mdcTabIndicator, mdcTab, parsley, phoneWidget, formData, jsCookie, moment, mdcSlider, mdcDialog) {

		$(function () {
			var query_string = queryString.parseArguments('survey/');
			var survey_id = cleanQueryParameter(query_string[0]);
			var survey_key = cleanQueryParameter(query_string[1]);
			var extranet_user = cleanQueryParameter(query_string[2]);
			var extranet_user_id;
			var authDialog;
			var defaultCountry;
			var stepCookie = jsCookie.get('survey-step');
			var surveyIdCookie = jsCookie.get('survey-id');
			var locale = jsCookie.get('locale');
			var cookieTime = 1 / 24;

			if (extranet_user) {
				$('#page-content').append(extranetAuthTemplate());
				$.ajax({
					url: '/api/authentication/extranet',
					type: 'POST',
					dataType: 'JSON'
				}).done(function (auth) {
					if (auth.extranet_user_id) {
						initSurvey();
					} else {
						authDialog = new mdcDialog.MDCDialog(document.getElementById('dialog_login'));
						authDialog.show();
						$('.mdc-text-field').each(function (index, value) {
							mdcTextField.MDCTextField.attachTo($(this)[0]);
						});
						$('.mdc-dialog__footer__button--cancel').on('click', function () {
							window.location.href = '/';
						});
						$('.mdc-dialog__footer__button--submit').on('click', function (e) {

							e.preventDefault();
							$.ajax({
								url: '/api/authentication/extranet',
								type: 'POST',
								dataType: 'JSON',
								data: {
									user_name: $('#login_user_name').val(),
									password: $('#login_password').val()
								}
							}).done(function (result) {
								if (result.error) {
									$('.extranet-auth--message').html(result.error);
								} else {
									authDialog.close();
									initSurvey();
								}
							});
						});
					}
				});

			} else {
				initSurvey();
			}

			function initSurvey() {
				$.ajax({
					url: '/api/survey/init',
					type: 'POST',
					dataType: 'JSON',
					data: {
						survey_id: survey_id,
						survey_key: survey_key
					}
				}).done(function (result) {
					if (result.answered) {
						window.location.href = "/survey/answered/" + survey_id + "/" + survey_key;
					} else if (result.error) {
						window.location.href = "/survey/error";
					}
				});

				//remove all cookies if the survey id doesn't match the current one
				if (surveyIdCookie != survey_id) {
					jsCookie.remove('survey-id');
					jsCookie.remove('survey-step');
					stepCookie = null;
					surveyIdCookie = null;
				}

				if (stepCookie === '1' && surveyIdCookie === survey_id) {
					step1();
				} else if (stepCookie === '2' && surveyIdCookie === survey_id) {
					step2();
				} else if (stepCookie === '3' && surveyIdCookie === survey_id) {
					step3();
				} else {
					introduction();
				}
			}
			/*
			INTRODUCTION
			*/
			function introduction() {
				$.ajax({
					type: "POST",
					url: "/api/survey/introduction",
					dataType: "json",
					data: {
						surveyId: survey_id,
						surveyKey: survey_key,
						locale: locale
					}
				}).done(function (data) {
					$('#page-content').append(introductionTemplate(data));
					jsCookie.set('survey-id', survey_id, {
						expires: cookieTime
					});
					
					
					$('.begin-survey').on('click', function () {
						$('#page-content').empty();
						step1();
					});
				});
			}

			/*
			==============================================
			==============================================
			==============================================
			STEP ONE 
			*/

			function step1() {
				window.Parsley
					.addValidator('servicePeriodValidator', {
						requirementType: 'string',
						validateString: function (value, requirement) {
							var match = value.match(/^([0-9]{2})(-|\/)([0-9]{4})$/);
							//test the service period to make sure its not too far in the past or in the future
							var datetimeCurrent = moment().utc();
							var datetimeCurrentYear = datetimeCurrent;
							datetimeCurrentYear = moment().format('YYYY');
							datetimeCurrentMonth = moment().format('MM');
							if (match && (match[3] > datetimeCurrentYear || (match[1] > datetimeCurrentMonth && match[3] == datetimeCurrentYear))) {
								//future date
								return false;
							} else if (match && (datetimeCurrentYear - match[3] > 5 || (parseInt(match[1]) > 12 || parseInt(match[1]) == 0))) {
								//past date
								return false;
							}
							return (match && match[0]) != null;
						}
					}).addValidator('postalCodeValidator', {
						requirementType: 'string',
						validateString: function (value, requirement) {
							var countryCode = $('select[name="country"]').val();
							postCodeValid = postcodeValidator(value, countryCode);
							return postCodeValid;
						}
					});
				jsCookie.set('survey-step', 1, {
					expires: cookieTime
				});
				$.ajax({
					type: "POST",
					url: "/api/survey/step1",
					dataType: "json",
					data: {
						locale: locale,
						surveyId: survey_id,
						surveyKey: survey_key
					}
				}).done(function (data) {
					if (data.service_period) {
						data.service_period = moment.utc(data.service_period).format('MM/YYYY');
					}

					data.telephone_validation = (jsCookie.get('phone-validation') == '1');
					$('#page-content').append(step1Template(data));
					$('.survey-step-1__phone-validation').val((jsCookie.get('phone-validation')));
					
					
					var extranet_user_id = data.extranet_user_id;
					var certified = data.certified;
					$('.survey-step-1__form').parsley();
					$('.mdc-text-field').each(function (index, value) {
						mdcTextField.MDCTextField.attachTo($(this)[0]);
					});
					const select = new mdcSelect.MDCSelect(document.querySelector('.mdc-select'));
					if (!data.phone_country) {
						var host = window.location.host;
						var hostSplit = host.split('.');
						var tld = hostSplit[hostSplit.length - 1];
						defaultCountry = tld.toUpperCase();
					} else {
						defaultCountry = data.phone_country;
					}
					$("#step_1_period").keyup(function (e) {
						if (e.keyCode != 8) {
							if ($(this).val().length == 2) {
								$(this).val($(this).val() + "/");
							}
						}
					});
					if (data.telephone_validation) {
						$('.survey-step-1__phone-widget').append(phoneWidgetTemplate({
							default_country: defaultCountry,
							required: "true",
							label: i18next.t('phone-widget:telephone'),
							name: 'mobile',
							mobile: data.mobile,
							id: 'telephone',
							lang: locale
						}));
					} else {
						$('.survey-step-1__phone-widget').append(phoneWidgetTemplate({
							default_country: defaultCountry,
							required: "true",
							label: i18next.t('phone-widget:mobile_phone'),
							name: 'mobile',
							mobile: data.mobile,
							id: 'mobile-phone',
							lang: locale
						}));
					}
					phoneWidget.init();

					$('.survey-step-1__sms-validation').on('click', function () {
						$(this).addClass('active');
						$('.survey-step-1__callback-validation').removeClass('active');
						$('.widget-phone-wrapper .mdc-floating-label').html(i18next.t('phone-widget:mobile_phone'));

						$('.survey-step-1__phone-validation').val(0);
					});
					$('.survey-step-1__callback-validation').on('click', function () {
						$(this).addClass('active');
						$('.survey-step-1__sms-validation').removeClass('active');
						$('.survey-step-1__phone-validation').val(1);
						$('.widget-phone-wrapper .mdc-floating-label').html(i18next.t('phone-widget:telephone'));
					});

					$('.survey-step-1__form input[name="period"]').on('keyup', function (e) {
						$(this).parsley().validate();
					});
					$('.survey-step-1__form input[name="postal_code"]').on('keyup', function (e) {
						$(this).parsley().validate();
					});
					$('.survey-step-1__form input[type="text"]').on('change', function (e) {

						$(e.target).parsley().whenValidate().then(function () {
							if ($('.survey-step-1__form input[name="phone_country"]').val()) {
								var phone_country = $('.survey-step-1__form input[name="phone_country"]').val();
							}
							var field = $(e.target)[0].name;
							var dataObj = {
								phone_country: phone_country,
								extranet_user_id: $('.survey-step-1__form input[name="extranet_user_id"]').val(),
								survey_id: survey_id,
								survey_key: survey_key
							};
							dataObj[field] = $(e.target)[0].value;
							saveStepData(dataObj, '/api/survey/step1/save');
						});

					});

					$('.survey-step-1__form select').on('change', function (e) {
						var field = $(e.target)[0].name;
						var dataObj = {
							extranet_user_id: $('.survey-step-1__form input[name="extranet_user_id"]').val(),
							survey_id: survey_id,
							survey_key: survey_key
						}
						dataObj[field] = $(e.target)[0].value;
						saveStepData(dataObj, '/api/survey/step1/save');
					});

					$('.survey-step-1__validate-btn').on('click', function (e) {
						step1FormData = {
							invoice_detail: $('.survey-step-1__form input[name="invoice_detail"]').val(),
							service_period: $('.survey-step-1__form input[name="service_period"]').val(),
							first_name: $('.survey-step-1__form input[name="first_name"]').val(),
							last_name: $('.survey-step-1__form input[name="last_name"]').val(),
							city: $('.survey-step-1__form input[name="city"]').val(),
							postal_code: $('.survey-step-1__form input[name="postal_code"]').val(),
							mobile: $('.survey-step-1__form input[name="mobile"]').val(),
							phone_country: $('.survey-step-1__form input[name="phone_country"]').val(),
							country: $('.survey-step-1__form select[name="country"]').val(),
							extranet_user_id: $('.survey-step-1__form input[name="extranet_user_id"]').val(),
							//phone_validation: $('.survey-step-1__form input[name="phone_validation"]').val(),
							survey_id: survey_id,
							survey_key: survey_key
						};

						$('.survey-step-1__form').parsley().whenValidate().then(async function () {

							const { valid } = await $.ajax({
								type: "POST",
								url: "/api/survey/phone-validation",
								dataType: "json",
								data: {
									survey_id: survey_id,
									phone_country: step1FormData['phone_country'],
									mobile: step1FormData['mobile'],
								}
							});
							if (valid) {
								$('#phone_number_reuse_warning').hide();
							} else {
								$('#phone_number_reuse_warning').show();
								return;
							}

							jsCookie.set('phone-validation', $('.survey-step-1__form input[name="phone_validation"]').val());

							saveStepData(step1FormData, '/api/survey/step1/save').done(function (result) {

								return result;
							}).then(function (result) {
								if ((extranet_user_id == null && certified == true)) {
									if ($('.survey-step-1__form input[name="phone_validation"]').val() == 0) {
										$.ajax({
											url: "/api/survey/sendsms",
											type: "post",
											data: {
												surveyId: survey_id,
												surveyKey: survey_key,
												mobile: $('.survey-step-1__form input[name="mobile"]').val(),
												country_code: $('.survey-step-1__form input[name="phone_country"]').val()
											},
											dataType: 'JSON',
										}).done(function (data) {
											if (!data.result) {
												jsCookie.set('sms-sending-error', true);
											} else {
												jsCookie.remove('sms-sending-error');
											}
											$('#page-content').empty();
											step2();
										});
									} else {
										if (result.result) {
											$('#page-content').empty();
											step2();
										}
									}
								} else {
									if (result.result) {
										$('#page-content').empty();
										step2();
									}
								}
							}).fail(function () {
								// An error occurred
							});
						})
						e.preventDefault();
						return false;
					});
				});
			}

			/*
			=======================================
			=======================================
			=======================================
			=======================================
			STEP 2
			*/
			function step2() {
				jsCookie.set('survey-step', 2, {
					expires: cookieTime
				});
				$.ajax({
					type: "POST",
					url: "/api/survey/step2",
					dataType: "json",
					data: {
						surveyId: survey_id,
						surveyKey: survey_key
					}
				}).done(function (data) {
					$('#page-content').append(step2Template(data));
					
					
					const satisSlider = new mdcSlider.MDCSlider(document.querySelector('.mdc-slider-satisfaction'));
					animateNotationCompany('.company-rating-progressbar');
					animateNotation('.your-score-progressbar');
					animateSliders(data);
					calculateSurveyRating(data.good_rating, data.bad_rating, satisSlider, data.satisfaction);
					if (data.satisfaction) {
						calculateSatisfactionRating(data.good_rating, data.bad_rating, data.satisfaction);
					}
					$('.survey-step-2__form').parsley({
						inputs: "textarea, input[type=hidden]",
						excluded: 'input[type=button], input[type=submit], input[type=reset]'
					});
					$(document).on('scroll', function () {
						if ($(window).scrollTop() > 175) {
							if ($('.mdc-top-app-bar').css('top') == '0px') {
								$('.survey-step-2__floating-score-box').removeClass('fixed');
								$('.survey-step-2__floating-score-box').addClass('top-fixed');
							} else {
								$('.survey-step-2__floating-score-box').removeClass('top-fixed');
								$('.survey-step-2__floating-score-box').addClass('fixed');
							}
						} else {
							$('.survey-step-2__floating-score-box').removeClass('top-fixed');
							$('.survey-step-2__floating-score-box').removeClass('fixed');
						}
					});
					$('.mdc-text-field').each(function (index, value) {
						mdcTextField.MDCTextField.attachTo($(this)[0]);
					});
					//
					if (data.suggestion_1) {
						$('.survey-step-2__form .survey-step-2__suggestion-box-1').find('.suggestion1-counter-amount').html($('.survey-step-2__form .survey-step-2__suggestion-box-1 textarea').val().length);
					}
					if (data.suggestion_2) {
						$('.survey-step-2__form .survey-step-2__suggestion-box-2').find('.suggestion2-counter-amount').html($('.survey-step-2__form .survey-step-2__suggestion-box-2 textarea').val().length);
					}
					if (data.suggestion_3) {
						$('.survey-step-2__form .survey-step-2__suggestion-box-3').find('.suggestion3-counter-amount').html($('.survey-step-2__form .survey-step-2__suggestion-box-3 textarea').val().length);
					}
					if (data.suggestion_4) {
						$('.survey-step-2__form .survey-step-2__suggestion-box-4').find('.suggestion4-counter-amount').html($('.survey-step-2__form .survey-step-2__suggestion-box-4 textarea').val().length);
					}
					if (data.suggestion_5) {
						$('.survey-step-2__form .survey-step-2__suggestion-box-5').find('.suggestion5-counter-amount').html($('.survey-step-2__form .survey-step-2__suggestion-box-5 textarea').val().length);
					}
					if (data.comment) {
						$('.survey-step-2__form #comment-box').find('.comment-counter-amount').html($('.survey-step-2__form #comment-box textarea').val().length);
					}
					/* 
					QUESTIONS 1 - 5 + Recommendation 
					*/
					let slider = [];
					for (let question = 1; question < 7; question++) {
						slider[question] = new mdcSlider.MDCSlider(document.querySelector('.mdc-slider-question-' + question));

						if (slider[question]) {
							(function () {
								var number = question;
								$('.survey-step-2__slider-minus-icon-' + number).on('click', function (e) {
									if (parseFloat(slider[number].value) > parseFloat(slider[number].min)) {
										var value = parseInt(slider[number].step);
										slider[number].stepDown(value);
										$('.mdc-slider-question-' + number).removeClass(function (index, className) {
											return (className.match(/(^|\s)slider-\S+/g) || []).join(' ');
										});
										$('input[name="question_' + number + '"]').val(slider[number].value);
										calculateSurveyRating(data.good_rating, data.bad_rating, satisSlider);
										if (slider[number].value < (data.good_rating) && slider[number].value >= (data.bad_rating)) {
											$('.survey-step-2__suggestion-box-' + number + ' button').addClass('active');
											$('.mdc-slider-question-' + number).addClass('slider-blue');
										} else if (slider[number].value < (data.bad_rating)) {
											$('.survey-step-2__suggestion-box-' + number + ' button').addClass('active');
											$('.mdc-slider-question-' + number).addClass('slider-red');
										} else {
											$('.survey-step-2__suggestion-box-' + number + ' button').removeClass('active');
											$('.mdc-slider-question-' + number).addClass('slider-green');
										}
										var question_number = "question_" + number;
										var dataObj = {
											extranet_user_id: $('.survey-step-2__form input[name="extranet_user_id"]').val(),
											survey_id: survey_id,
											survey_key: survey_key
										}
										dataObj[question_number] = slider[number].value
										saveStepData(dataObj, '/api/survey/step2/save');
										$('.survey-step-2__floating-score-box--desktop').css({
											'position': 'absolute',
											'width': '353px'
										});
										$('.survey-step-2__floating-score-box--desktop').animate({
											'top': $('#question-' + number).offset().top
										});

										animateNotation('.your-score-progressbar');
									}
								});

								$('.survey-step-2__slider-plus-icon-' + number).on('click', function (e) {
									if (parseFloat(slider[number].value) < parseFloat(slider[number].max)) {
										var value = parseInt(slider[number].step);
										slider[number].stepUp(value);
										$('.mdc-slider-question-' + number).removeClass(function (index, className) {
											return (className.match(/(^|\s)slider-\S+/g) || []).join(' ');
										});
										$('input[name="question_' + number + '"]').val(slider[number].value);
										if (slider[number].value < (data.good_rating) && slider[number].value >= (data.bad_rating)) {
											$('.survey-step-2__suggestion-box-' + number + ' button').addClass('active');
											$('.mdc-slider-question-' + number).addClass('slider-blue');
										} else if (slider[number].value < (data.bad_rating)) {
											$('.survey-step-2__suggestion-box-' + number + ' button').addClass('active');
											$('.mdc-slider-question-' + number).addClass('slider-red');
										} else {
											$('.survey-step-2__suggestion-box-' + number + ' button').removeClass('active');
											$('.mdc-slider-question-' + number).addClass('slider-green');
										}
										calculateSurveyRating(data.good_rating, data.bad_rating, satisSlider);

										var question_number = "question_" + number;
										var dataObj = {
											extranet_user_id: $('.survey-step-2__form input[name="extranet_user_id"]').val(),
											survey_id: survey_id,
											survey_key: survey_key
										}
										dataObj[question_number] = slider[number].value;
										saveStepData(dataObj, '/api/survey/step2/save');
										$('.survey-step-2__floating-score-box--desktop').css({
											'position': 'absolute',
											'width': '353px'
										});
										$('.survey-step-2__floating-score-box--desktop').animate({
											'top': $('#question-' + number).offset().top
										});

										animateNotation('.your-score-progressbar');
									}
								});

								slider[number].listen('MDCSlider:change', function () {
									$('.mdc-slider-question-' + number).removeClass(function (index, className) {
										return (className.match(/(^|\s)slider-\S+/g) || []).join(' ');
									});
									$('input[name="question_' + number + '"]').val(slider[number].value);

									if (slider[number].value < (data.good_rating) && slider[number].value >= (data.bad_rating)) {
										$('.survey-step-2__suggestion-box-' + number + ' button').addClass('active');
										$('.mdc-slider-question-' + number).addClass('slider-blue');
									} else if (slider[number].value < (data.bad_rating)) {
										$('.survey-step-2__suggestion-box-' + number + ' button').addClass('active');
										$('.mdc-slider-question-' + number).addClass('slider-red');
									} else {
										$('.survey-step-2__suggestion-box-' + number + ' button').removeClass('active');
										$('.mdc-slider-question-' + number).addClass('slider-green');
									}
									$('input[name="question_' + number + '"]').parsley().validate();
									calculateSurveyRating(data.good_rating, data.bad_rating, satisSlider);
									var question_number = "question_" + number;
									var dataObj = {
										extranet_user_id: $('.survey-step-2__form input[name="extranet_user_id"]').val(),
										survey_id: survey_id,
										survey_key: survey_key
									};
									dataObj[question_number] = slider[number].value;
									saveStepData(dataObj, '/api/survey/step2/save');
									//move the floating score thing
									$('.survey-step-2__floating-score-box--desktop').css({
										'position': 'absolute',
										'width': '353px'
									});
									$('.survey-step-2__floating-score-box--desktop').animate({
										'top': $('#question-' + number).offset().top
									});

									animateNotation('.your-score-progressbar');
								});

								$('.survey-step-2__suggestion-box-' + number + ' .survey-step-2__suggestion-box-wrapper').hide();
								$('.survey-step-2__suggestion-box-' + number + ' button').on('click', function (e) {
									e.preventDefault();
									$('.survey-step-2__suggestion-box-' + number + ' .survey-step-2__suggestion-box-wrapper').toggle();
								});

								$('.survey-step-2__suggestion-box-' + number + ' .survey-step-2__suggestion-box-wrapper textarea').on('keyup', function () {
									$(this).parent().find('.suggestion' + number + '-counter-amount').html($(this).val().length);
								});

								$('.survey-step-2__suggestion-box-' + number + ' .survey-step-2__suggestion-box-wrapper textarea').on('blur', function () {
									var suggestion_box = "suggestion_" + number;
									var suggestionData = {
										extranet_user_id: $('.survey-step-2__form input[name="extranet_user_id"]').val(),
										survey_id: survey_id,
										survey_key: survey_key
									};
									suggestionData[suggestion_box] = $('textarea[name="suggestion_' + number + '"]').val();
									saveStepData(suggestionData, '/api/survey/step2/save');
								});
							})();
						}
					}

					/* 
					HOW TO DO COMMENT
					*/
					$('.survey-step-2__constructive-comment-desc').hide();
					$('.survey-step-2__constructive-comment').on('click', function (argument) {
						$('.survey-step-2__constructive-comment-desc').toggle();
					});
					if ($('.survey-step-2__constructive-comment-desc--desktop').length > 0) {
						var anchorY = $('#comment-box').offset();
						$('.survey-step-2__constructive-comment-desc--desktop').css('top', anchorY.top + 50);
					}
					$('.survey-step-2__form #comment-box textarea').on('keyup', function () {
						$(this).parent().find('.comment-counter-amount').html($(this).val().length);
					});
					$('.survey-step-2__form #comment-box textarea').on('change', function () {
						commentData = {
							"comment": $('textarea[name="comment"]').val(),
							extranet_user_id: $('.survey-step-2__form input[name="extranet_user_id"]').val(),
							survey_id: survey_id,
							survey_key: survey_key
						};
						saveStepData(commentData, '/api/survey/step2/save');
					});

					/* 
					GENERAL SATISFACTION
					*/

					$('.survey-step-2__slider-minus-icon-satisfaction').on('click', function (e) {
						if (parseFloat(satisSlider.value) > parseFloat(satisSlider.min)) {
							satisSlider.stepDown(satisSlider.step);
							saveStepData({
								"satisfaction": satisSlider.value,
								extranet_user_id: $('.survey-step-2__form input[name="extranet_user_id"]').val(),
								survey_id: survey_id,
								survey_key: survey_key
							}, '/api/survey/step2/save');
							calculateSatisfactionRating(data.good_rating, data.bad_rating, satisSlider.value);
							animateNotation('.your-score-progressbar');
						}
					});

					$('.survey-step-2__slider-plus-icon-satisfaction').on('click', function (e) {
						if (parseFloat(satisSlider.value) < parseFloat(satisSlider.max)) {
							satisSlider.stepUp(satisSlider.step);
							saveStepData({
								"satisfaction": satisSlider.value,
								extranet_user_id: $('.survey-step-2__form input[name="extranet_user_id"]').val(),
								survey_id: survey_id,
								survey_key: survey_key
							}, '/api/survey/step2/save');
							calculateSatisfactionRating(data.good_rating, data.bad_rating, satisSlider.value);
							animateNotation('.your-score-progressbar');

						}
					});

					satisSlider.listen('MDCSlider:change', function () {
						$('.mdc-slider-satisfaction').removeClass(function (index, className) {
							return (className.match(/(^|\s)slider-\S+/g) || []).join(' ');
						});
						$('.mdc-slider-satisfaction .mdc-slider__pin-value-marker').html(round((satisSlider.value / 10), 1))

						$('input[name="satisfaction"]').val(satisSlider.value / 10);
						if (satisSlider.value < (data.good_rating) && satisSlider.value > (data.bad_rating)) {
							$('.mdc-slider-satisfaction').addClass('slider-blue');
						} else if (satisSlider.value < (data.bad_rating)) {
							$('.mdc-slider-satisfaction').addClass('slider-red');
						} else {
							$('.mdc-slider-satisfaction').addClass('slider-green');
						}
						saveStepData({
							"satisfaction": satisSlider.value,
							extranet_user_id: $('.survey-step-2__form input[name="extranet_user_id"]').val(),
							survey_id: survey_id,
							survey_key: survey_key
						}, '/api/survey/step2/save');
						calculateSatisfactionRating(data.good_rating, data.bad_rating, satisSlider.value);
						animateNotation('.your-score-progressbar');

					});

					/* BACK */

					$('.survey-step-2__back-btn').on('click', function (e) {
						e.preventDefault();
						e.stopPropagation();
						jsCookie.set('survey-step', 1, {
							expires: cookieTime
						});
						location.reload();
					});

					/* 
					VALIDATE 
					*/
					$('.survey-step-2__next-btn').on('click', function (e) {
						var step2FormData = {
							"question_1": slider[1].value,
							"suggestion_1": $('textarea[name="suggestion_1"]').val(),
							"question_2": slider[2].value,
							"suggestion_2": $('textarea[name="suggestion_2"]').val(),
							"question_3": slider[3].value,
							"suggestion_3": $('textarea[name="suggestion_3"]').val(),
							"question_4": slider[4].value,
							"suggestion_4": $('textarea[name="suggestion_4"]').val(),
							"question_5": slider[5].value,
							"suggestion_5": $('textarea[name="suggestion_5"]').val(),
							"question_6": slider[6].value,
							"comment": $('textarea[name="comment"]').val(),
							"satisfaction": satisSlider.value,
							extranet_user_id: $('.survey-step-2__form input[name="extranet_user_id"]').val(),
							survey_id: survey_id,
							survey_key: survey_key
						};

						if ($('.survey-step-2__form').parsley().validate()) {
							saveStepData(step2FormData, '/api/survey/step2/save').done(function (result) {
								if (result.result) {
									$('#page-content').empty();
									step3();
								}
							}).fail(function () {
								// An error occurred
							});
						}
						e.preventDefault();
						return false;
					});
				});
			}

			/*
			 ================================
			 ================================
			 ================================
				STEP 3
			*/
			function step3() {
				jsCookie.set('survey-step', 3, {
					expires: cookieTime
				});
				var telephoneVadidated = false;
				var sms_error = jsCookie.get('sms-sending-error');
				$.ajax({
					method: 'POST',
					url: '/api/survey/step3',
					dataType: 'JSON',
					data: {
						surveyId: survey_id,
						surveyKey: survey_key
					}
				}).done(function (data) {
					$('#page-content').append(step3Template(data));
					
					
					$('.survey-step-3__form').parsley({
						inputs: "textarea, input[type=hidden], input[type=text]",
						excluded: 'input[type=button], input[type=submit], input[type=reset]'
					});
					var extranet_user_id = data.extranet_user_id;
					var certified = data.certified;
					data.telephone_validation = (jsCookie.get('phone-validation') == '1');
					if (!data.number) {
						var host = window.location.host;
						var hostSplit = host.split('.');
						var tld = hostSplit[hostSplit.length - 1];
						defaultCountry = tld.toUpperCase();
					} else {
						defaultCountry = data.default_country;
					}

					$('.mdc-chip-set').each(function (index, value) {
						const chipSet = mdcChips.MDCChipSet.attachTo($(this)[0]);
						chipSet.listen('MDCChip:interaction', function (chip) {
							if ($(chip.target).hasClass('first-choice') && $(chip.target).data('chip') == 1) {
								$('.other-reviews-help').show();
							} else if ($(chip.target).hasClass('first-choice') && $(chip.target).data('chip') == 0) {
								$('.other-reviews-help').hide();
							}

							if ($(chip.target).hasClass('google_share_choice') && $(chip.target).data('chip') == 1) {
								$('.content_google_share_choice_no').hide();
								$('.content_google_share_choice_yes').show();
							} else if ($(chip.target).hasClass('google_share_choice') && $(chip.target).data('chip') == 0) {
								$('.content_google_share_choice_yes').hide();
								$('.content_google_share_choice_no').show();
							}

							$(value).find('input[type="hidden"]').val($(chip.target).data('chip'));
							$(value).find('input[type="hidden"]').parsley().validate();
							if ($('.parsley-errors-list.filled')) {

								$('.parsley-errors-list.filled').remove();
							}

							var field_name = $(value).find('input[type="hidden"]').attr('name');
							var saveData = {
								extranet_user_id: $('.survey-step-3__form input[name="extranet_user_id"]').val(),
								survey_id: survey_id,
								survey_key: survey_key
							}
							saveData[field_name] = $('input[name="' + field_name + '"]').val();
							if ($('input[name="roi_seen"]').val() == 0) {
								saveData.roi_help = null
							} else {
								saveData.roi_help = $('input[name="roi_help"]').val();
							}
							saveStepData(saveData, '/api/survey/step3/save');
						});
					});

					$('.other-reviews-help').hide();
					if (data.roi_seen == 1) {
						$('.other-reviews-help').show();
					}
					$('.phone-widget-container').hide();

					var validationTabs = $('.survey-step-3__form .survey-step-3__validation-bar .mdc-tab');
					var tabIndicator = new mdcTabIndicator.MDCTabIndicator(document.querySelector('.survey-step-3__validation-bar .mdc-tab-indicator'));
					$.each(validationTabs, function (index, object) {
						const tab = new mdcTab.MDCTab($(this)[0]);
						tab.listen('MDCTab:interacted', function (t) {
							$('#validation-error-container').removeClass('parsley-error');
							$('#validation-error-container .parsley-errors-list').remove();
							$('.survey-step-3__validation-bar .mdc-tab').removeClass('mdc-tab--active');
							$('.survey-step-3__validation-bar .mdc-tab .mdc-tab-indicator').removeClass('mdc-tab-indicator--active');
							$('.survey-step-3__validation-bar .mdc-tab[data-target="' + $(t.target).data().target + '"]').addClass('mdc-tab--active');
							$('.survey-step-3__validation-bar .mdc-tab[data-target="' + $(t.target).data().target + '"] .mdc-tab-indicator').addClass('mdc-tab-indicator--active');
							$('.survey-step-3__verification-container').hide();
							$('#survey-step-3__' + $(t.target).data().target).show();
							if ($('#survey-step-3__phone-verify').is(':visible')) {
								setLandPhone();
								jsCookie.set('phone-validation', 1);
								$('.change-validation__sms').hide();
								$('.change-validation__phone').show();
								$('.phone-widget-container').show();
							} else {
								setMobile();
								jsCookie.remove('phone-validation');
								$('.change-validation__sms').show();
								$('.change-validation__phone').hide();
								$('.phone-widget-container').hide();
							}
						});
						tab.listen('click', function (e) {
							e.preventDefault();
							e.stopPropagation();
						});
					});


					/*
					SMS VALIDATION
					*/
					var securityCode = new mdcTextField.MDCTextField(document.querySelector('.security-code'));
					if (data.telephone_validation) {
						$('.survey-step-3__validation-bar .mdc-tab').removeClass('mdc-tab--active');
						$('.survey-step-3__validation-bar .mdc-tab .mdc-tab-indicator').removeClass('mdc-tab-indicator--active');
						$('.survey-step-3__validation-bar .mdc-tab[data-target="phone-verify"]').addClass('mdc-tab--active');
						$('.survey-step-3__validation-bar .mdc-tab[data-target="phone-verify"] .mdc-tab-indicator').addClass('mdc-tab-indicator--active');
						$('.survey-step-3__verification-container').hide();
						$('.change-validation__sms').hide();
						$('.change-validation__phone').show();
						setTimeout(function () {
							$('#survey-step-3__phone-verify').show();
							setLandPhone();
							$('.phone-widget-container').show();
							//phoneWidget.init();
						}, 1000);
					} else {
						$('.change-validation__sms').show();
						$('.change-validation__phone').hide();
					}

					if (sms_error == 'true') {
						$('.survey-step-3-sms-verify__default-container').hide();
						$('.survey-step-3-sms-verify__default-container .survey-step-3-sms-verify__resend-phone').hide();
						$('.survey-step-3-sms-verify__error-container .survey-step-3-sms-verify__resend-phone').show();
						setMobile();
						$('.phone-widget-container').show();
					} else {
						$('.survey-step-3-sms-verify__error-container').hide();
						$('.survey-step-3-sms-verify__default-container .survey-step-3-sms-verify__resend-phone').hide();
						$('.survey-step-3-sms-verify__error-container .survey-step-3-sms-verify__resend-phone').hide();
						$('.phone-widget-container').hide();
					}


					$('.survey-step-3-sms-verify__not-recieved ').on('click', function () {
						setMobile();
						$('.phone-widget-container').toggle();
					});

					$('.survey-step-3-sms-verify__error-container-resend-toggle').on('click', function () {
						setMobile();
						$('.phone-widget-container').toggle();
					});

					$(document).on('click', '.survey-step-3__resend-text-button', async function (e) {
						e.preventDefault();
						e.stopPropagation();

						$('#phone_number_reuse_warning').hide();
						const { valid } = await $.ajax({
							type: "POST",
							url: "/api/survey/phone-validation",
							dataType: "json",
							data: {
								survey_id: survey_id,
								phone_country: $('.survey-step-3__form input[name="phone_country"]').val(),
								mobile: $('.survey-step-3__form input[name="resend-phone"]').val(),
							}
						});
						if (!valid) {
							$('#phone_number_reuse_warning').show();
							return;
						}

						$.ajax({
							url: "/api/survey/sendsms",
							type: "post",
							data: {
								surveyId: survey_id,
								surveyKey: survey_key,
								mobile: $('.survey-step-3__form input[name="resend-phone"]').val(),
								country_code: $('.survey-step-3__form input[name="phone_country"]').val()
							},
							dataType: 'JSON',
						}).done(function (data) {
							if (data.result == false) {
								$('.survey-step-3-sms-verify__default-container').hide();
								$('.survey-step-3-sms-verify__error-container').show();
							} else {
								jsCookie.remove('sms-sending-error');
								$('.survey-step-3-sms-verify__error-container').hide();
								$('.survey-step-3-sms-verify__default-container').show();
							}
						});
					});
					$('.survey-step-3-sms-verify__error-container-change-method').on('click', function () {
						$('.survey-step-3__validation-bar .mdc-tab').removeClass('mdc-tab--active');
						$('.survey-step-3__validation-bar .mdc-tab .mdc-tab-indicator').removeClass('mdc-tab-indicator--active');
						$('.survey-step-3__validation-bar .mdc-tab[data-target="phone-verify"]').addClass('mdc-tab--active');
						$('.survey-step-3__validation-bar .mdc-tab[data-target="phone-verify"] .mdc-tab-indicator').addClass('mdc-tab-indicator--active');
						$('.survey-step-3__verification-container').hide();
						$('#survey-step-3__phone-verify').show();
						setLandPhone();
						jsCookie.set('phone-validation', 1);
						$('.phone-widget-container').show();
					});

					/*
					PHONE VALIDATION
					*/
					$('#survey-step-3__phone-verify').hide();
					$('.survey-step-3-phone-verify__error-container').hide();
					$('.survey-step-3-phone-verify--in-progress').hide();
					$('.survey-step-3-phone-verify--success').hide();
					$('.survey-step-3-phone-verify__error-container .survey-step-3-phone-verify__resend-phone').hide();

					$('.survey-step-3-phone-verify__error-container-resend-toggle').on('click', function () {
						$('.survey-step-3-phone-verify__error-container .survey-step-3-phone-verify__resend-phone').toggle();
					});

					if ($('.survey-step-3__change-validation').length > 0) {
						var anchorY = $('.survey-step-3__validation-bar').offset();
						$('.survey-step-3__change-validation').css('top', anchorY.top);
					}
					if ($('.survey-step-3__change-validation-button').length > 0) {
						$('.survey-step-3__change-validation-button').on('click', function () {
							$('.survey-step-3__validation-bar .mdc-tab').removeClass('mdc-tab--active');
							$('.survey-step-3__validation-bar .mdc-tab .mdc-tab-indicator').removeClass('mdc-tab-indicator--active');
							$('.survey-step-3__validation-bar .mdc-tab[data-target="' + $(this).data('method') + '-verify"]').addClass('mdc-tab--active');
							$('.survey-step-3__validation-bar .mdc-tab[data-target="' + $(this).data('method') + '-verify"] .mdc-tab-indicator').addClass('mdc-tab-indicator--active');
							$('.survey-step-3__verification-container').hide();
							$('#survey-step-3__' + $(this).data('method') + '-verify').show();
							switch ($(this).data('method')) {
								case 'sms':
									$('.change-validation__phone').hide();
									$('.change-validation__sms').show();
									jsCookie.remove('phone-validation');
									setMobile();
									break;
								case 'phone':
									$('.change-validation__sms').hide();
									$('.change-validation__phone').show();
									jsCookie.set('phone-validation', 1);
									setLandPhone();
									break;
							}
							$('#validation-error-container').removeClass('parsley-error');
							$('#validation-error-container .parsley-errors-list').remove();
							$('.phone-widget-container').show();
						});
					}

					$('.survey-step-3-phone-verify__error-container-change-method').on('click', function () {
						$('.survey-step-3__validation-bar .mdc-tab').removeClass('mdc-tab--active');
						$('.survey-step-3__validation-bar .mdc-tab .mdc-tab-indicator').removeClass('mdc-tab-indicator--active');
						$('.survey-step-3__validation-bar .mdc-tab[data-target="sms-verify"]').addClass('mdc-tab--active');
						$('.survey-step-3__validation-bar .mdc-tab[data-target="sms-verify"] .mdc-tab-indicator').addClass('mdc-tab-indicator--active');
						$('.survey-step-3__verification-container').hide();
						$('#survey-step-3__sms-verify').show();
						setMobile();
						$('.phone-widget-container').show();
					});

					$('.phone-widget-container .phone-widget').append(phoneWidgetTemplate({
						default_country: defaultCountry,
						label: i18next.t('phone-widget:mobile_phone'),
						name: 'resend-phone',
						mobile: data.number,
						id: 'mobile-phone',
						lang: locale
					}));

					phoneWidget.init();

					$(document).on('click', '.survey-step-3__phone-call-me', async function (e) {
						e.preventDefault();
						e.stopPropagation();

						$('#phone_number_reuse_warning').hide();
						const { valid } = await $.ajax({
							type: "POST",
							url: "/api/survey/phone-validation",
							dataType: "json",
							data: {
								survey_id: survey_id,
								phone_country: $('.survey-step-3__form input[name="phone_country"]').val(),
								mobile: $('input[name="validate_voice_number"]').val(),
							}
						});
						if (!valid) {
							$('#phone_number_reuse_warning').show();
							return;
						}

						$('.survey-step-3__verification-container .survey-step-3-phone-verify--initial').hide();
						$('.survey-step-3__verification-container .survey-step-3-phone-verify__error-container').hide();
						$('.survey-step-3__verification-container .survey-step-3-phone-verify--in-progress').show();
						$.ajax({
							type: "POST",
							url: "/api/survey/call",
							data: {
								surveyId: survey_id,
								surveyKey: survey_key,
								validate_voice_number: $('input[name="validate_voice_number"]').val(),
								country_code: $('.survey-step-3__form input[name="phone_country"]').val()
							},
							dataType: 'json'
						}).done(function (result) {
							jsCookie.set('phone-validation', 1);
							if (result.valid == false) {
								window.location.reload();
							} else if (!result.error) {
								ModalInterval = null;
								if (ModalInterval == null) {
									ModalInterval = setInterval(function () {
										$.ajax({
											url: '/api/survey/call/checkstatus',
											type: 'POST',
											dataType: 'json',
											success: function (data) {
												if (data.status == 1) {
													clearInterval(ModalInterval);
													ModalInterval = null;
													$('.survey-step-3-phone-verify--in-progress').hide();
													$('.survey-step-3-phone-verify--success').show();
													telephoneVadidated = true;
												} else if (data.status == 2) {
													clearInterval(ModalInterval);
													ModalInterval = null;
													$('.survey-step-3-phone-verify--in-progress').hide();
													$('.survey-step-3-phone-verify__error-container').show();
												}
											}
										});
									}, 1000);
								}
							} else {
								$('.survey-step-3-phone-verify--in-progress').hide();
								$('.survey-step-3-phone-verify__error-container').show();
							}
						});

					});


					$(document).on('change', 'input[name="google_share"]', function () {
						console.log($(this).val());

					});

					$('.survey-step-3__back-btn').on('click', function (e) {
						e.preventDefault();
						e.stopPropagation();
						jsCookie.set('survey-step', 2, {
							expires: cookieTime
						});
						location.reload();
					});
					/* 
					==============================
					==============================
					==============================
					SUBMIT STEP
					*/
					$('.survey-step-3__submit-btn').on('click', function (e) {
						e.preventDefault();
						e.stopPropagation();
						data.telephone_validation = (jsCookie.get('phone-validation') == '1');
						if ($('input[name="read_term"]').val() == '1') {
							if ((extranet_user_id == null && certified == true)) {
								if (telephoneVadidated || $('input[name="security-code"]').val()) {
									if ($('#google-share-error-container').length > 0 && $('input[name="google_share"]').val() === '1' || $('input[name="google_share"]').val() === '0') {
										$('.survey-step-3__form').parsley().whenValidate().then(function () {
											$('#validation-error-container').removeClass('parsley-error');
											$('#validation-error-container .parsley-errors-list').remove();
											$('.survey-step-3__submit-btn').before('<div class="plain-overlay__icon"></div>');
											if (!data.telephone_validation && $('input[name="security-code"]').val()) {
												$.ajax({
													url: '/api/survey/smsverify',
													type: 'POST',
													data: {
														surveyId: survey_id,
														surveyKey: survey_key,
														validate_sms_code: $('input[name="security-code"]').val()
													},
													dataType: 'JSON'
												}).done(function (data) {
													if (data.result) {
														$('#survey-step-3__sms-verify .parsley-errors-list').remove()
														saveStepData({
															roi_seen: $('input[name="roi_seen"]').val(),
															roi_help: $('input[name="roi_help"]').val(),
															survey_interest: $('input[name="survey_interest"]').val(),
															contact: $('input[name="contact"]').val(),
															google_share: $('input[name="google_share"]').val(),
															survey_id: survey_id,
															survey_key: survey_key,
															submit: true
														}, '/api/survey/step3/save').done(function (result) {
															if (result.complete) {
																$('#page-content').empty();
																jsCookie.remove('survey-id');
																jsCookie.remove('survey-step');
																jsCookie.remove('sms-sending-error');
																window.location.href = "/survey/thankyou/" + survey_id + "/" + survey_key;
															}
														});
													} else if (data.valid == false) {
														window.location.reload();
													} else {
														$('.plain-overlay__icon').remove();
														$('#survey-step-3__sms-verify').addClass('parsley-error');
														$('#survey-step-3__sms-verify').append('<ul class="parsley-errors-list filled" id="parsley-id-13"><li class="parsley-required">' + i18next.t('survey-step3:sms_code_incorrect') + '</li></ul>');
													}
												});
											} else if (data.telephone_validation && telephoneVadidated) {
												saveStepData({
													roi_seen: $('input[name="roi_seen"]').val(),
													roi_help: $('input[name="roi_help"]').val(),
													survey_interest: $('input[name="survey_interest"]').val(),
													contact: $('input[name="contact"]').val(),
													google_share: $('input[name="google_share"]').val(),
													survey_id: survey_id,
													survey_key: survey_key,
													submit: true
												}, '/api/survey/step3/save').done(function (result) {
													if (result.complete) {
														$('#page-content').empty();
														jsCookie.remove('survey-id');
														jsCookie.remove('survey-step');
														jsCookie.remove('sms-sending-error');
														window.location.href = "/survey/thankyou/" + survey_id + "/" + survey_key;
													}
												});
											}

										});
									} else {
										if ($('#google-share-error-container').length > 0) {
											$('#google-share-error-container').removeClass('parsley-error');
											$('#google-share-error-container .parsley-errors-list').remove();
											$('#google-share-error-container').addClass('parsley-error');
											$('#google-share-error-container').append('<ul class="parsley-errors-list filled" id="parsley-id-13"><li class="parsley-required">' + i18next.t('survey-step3:share_on_google_validation') + '</li></ul>');
											$('html, body').animate({
												scrollTop: $("#google-share-error-container").offset().top
											}, 500);
										} else {
											$('.survey-step-3__submit-btn').before('<div class="plain-overlay__icon"></div>');
											saveStepData({
												roi_seen: $('input[name="roi_seen"]').val(),
												roi_help: $('input[name="roi_help"]').val(),
												survey_interest: $('input[name="survey_interest"]').val(),
												contact: $('input[name="contact"]').val(),
												extranet_user_id: $('.survey-step-3__form input[name="extranet_user_id"]').val(),
												survey_id: survey_id,
												survey_key: survey_key,
												submit: true
											}, '/api/survey/step3/save').done(function (result) {
												if (result.complete) {
													$('#page-content').empty();
													jsCookie.remove('survey-id');
													jsCookie.remove('survey-step');
													jsCookie.remove('sms-sending-error');
													window.location.href = "/survey/thankyou/" + survey_id + "/" + survey_key;
												}
											});
										}
									}
								} else {
									$('#validation-error-container').addClass('parsley-error');
									$('#validation-error-container').append('<ul class="parsley-errors-list filled" id="parsley-id-13"><li class="parsley-required">' + i18next.t('survey-step3:validation_error_message') + '</li></ul>');
								}
							} else {
								$('.survey-step-3__submit-btn').before('<div class="plain-overlay__icon"></div>');
								saveStepData({
									roi_seen: $('input[name="roi_seen"]').val(),
									roi_help: $('input[name="roi_help"]').val(),
									survey_interest: $('input[name="survey_interest"]').val(),
									contact: $('input[name="contact"]').val(),
									google_share: $('input[name="google_share"]').val(),
									extranet_user_id: $('.survey-step-3__form input[name="extranet_user_id"]').val(),
									survey_id: survey_id,
									survey_key: survey_key,
									submit: true
								}, '/api/survey/step3/save').done(function (result) {
									if (result.complete) {
										$('#page-content').empty();
										jsCookie.remove('survey-id');
										jsCookie.remove('survey-step');
										jsCookie.remove('sms-sending-error');
										window.location.href = "/survey/thankyou/" + survey_id + "/" + survey_key;
									}
								});
							}
						} else {
							$('#terms-error-container').removeClass('parsley-error');
							$('#terms-error-container .parsley-errors-list').remove();
							$('#terms-error-container').addClass('parsley-error');
							$('#terms-error-container').append('<ul class="parsley-errors-list filled" id="parsley-id-13"><li class="parsley-required">' + i18next.t('survey-step3:terms_conditions_validate') + '</li></ul>');
							$('html, body').animate({
								scrollTop: $("#terms-error-container").offset().top
							}, 500);
						}
					});
				});
			}

			/**************************************
			 * 
			 * 
			HELPER FUNCTIONS
			***************************************
			*/
			function saveStepData(formData, apiUrl) {
				return $.ajax({
					url: apiUrl,
					data: formData,
					type: 'POST',
					dataType: 'json'
				}).done(function (result) {
					if (result.valid == false) {
						return window.location.reload();
					}
				});
			}

			function animateNotation(element) {
				$(element + ' .mdc-linear-progress__bar').addClass('animated');
				$(element).find('.mdc-linear-progress__bar').css({
					'-webkit-transform': 'scaleX(' + $(element).find('.your-score').html() / 10 + ')',
					'-moz-transform': 'scaleX(' + $(element).find('.your-score').html() / 10 + ')',
					'-ms-transform': 'scaleX(' + $(element).find('.your-score').html() / 10 + ')',
					'-o-transform': 'scaleX(' + $(element).find('.your-score').html() / 10 + ')',
					'transform': 'scaleX(' + $(element).find('.your-score').html() / 10 + ')'
				});
			}

			function animateSliders(data) {
				if (data.question_1 && data.question_2 && data.question_3 && data.question_4 && data.question_5 && data.question_6) {
					var slider = [];
					for (let question = 1; question < 7; question++) {
						var number = question;
						slider[question] = new mdcSlider.MDCSlider(document.querySelector('.mdc-slider-question-' + question));
						$('.mdc-slider-question-' + number).removeClass(function (index, className) {
							return (className.match(/(^|\s)slider-\S+/g) || []).join(' ');
						});
						$('input[name="question_' + number + '"]').val(slider[number].value);

						if (slider[number].value < (data.good_rating) && slider[number].value >= (data.bad_rating)) {
							$('.survey-step-2__suggestion-box-' + number + ' button').addClass('active');
							$('.mdc-slider-question-' + number).addClass('slider-blue');
						} else if (slider[number].value < (data.bad_rating)) {
							$('.survey-step-2__suggestion-box-' + number + ' button').addClass('active');
							$('.mdc-slider-question-' + number).addClass('slider-red');
						} else {
							$('.survey-step-2__suggestion-box-' + number + ' button').removeClass('active');
							$('.mdc-slider-question-' + number).addClass('slider-green');
						}
					}
				}
			}

			function animateNotationCompany(element) {
				$.each($(element), function (parent, value) {
					$(value).find('.mdc-linear-progress__bar').addClass('animated');
					$(value).find('.mdc-linear-progress__bar').css({
						'-webkit-transform': 'scaleX(' + $(value).find('.our-company-total').html() / 10 + ')',
						'-moz-transform': 'scaleX(' + $(value).find('.our-company-total').html() / 10 + ')',
						'-ms-transform': 'scaleX(' + $(value).find('.our-company-total').html() / 10 + ')',
						'-o-transform': 'scaleX(' + $(value).find('.our-company-total').html() / 10 + ')',
						'transform': 'scaleX(' + $(value).find('.our-company-total').html() / 10 + ')'
					});
				});
			}

			function calculateSurveyRating(impression_good, impression_bad, satisSlider, satisValue) {
				var Total = 0;
				var Divider = 0;

				for (var loop = 1; loop <= 5; loop++) {
					if ($('form[class="survey-step-2__form"] input[name="question_' + loop + '"]').val()) {
						Total += parseInt($('form[class="survey-step-2__form"] input[name="question_' + loop + '"]').val());
						Divider++;
					}
				}

				if ($('input[name="question_6"]').val()) {
					Total += parseInt($('input[name="question_6"]').val());
					Divider++;
				}

				if (satisValue) {
					Rating = parseFloat(satisValue);
				} else {
					Rating = parseFloat(Total / Divider);
				}
				$('.your-score').html(round((Rating / 10), 1));
				$('.your-score-progressbar .mdc-linear-progress__bar').data("value", Math.round(Rating / 10));
				satisSlider.value = round(Rating, 1);
				$('#satisfaction-question .survey-step-2__satisfaction-score').html(Rating / 10);
				$('input[name="satisfaction"]').val(round(Rating, 1));
				$('.your-score-progressbar .mdc-linear-progress__bar-inner').removeClass(function (index, className) {
					return (className.match(/(^|\s)progress-bar-\S+/g) || []).join(' ');
				});

				$('.your-score-progressbar .your-score').removeClass(function (index, className) {
					return (className.match(/(^|\s)color-\S+/g) || []).join(' ');
				});

				if (Rating) {
					if (Rating >= parseInt(impression_good)) {
						$('#notation_smiley_survey_question_mob').attr('class', 'survey-step-2__floating-score-box-smiley notation-smiley-good');
						$('#notation_smiley_survey_question_desk').attr('class', 'survey-step-2__floating-score-box-smiley notation-smiley-good');
						$('.your-score-progressbar .mdc-linear-progress__bar-inner').addClass('progress-bar-green');
						$('.your-score-progressbar .your-score').addClass('color-green');
					} else if (Rating >= parseInt(impression_bad)) {
						$('#notation_smiley_survey_question_mob').attr('class', 'survey-step-2__floating-score-box-smiley notation-smiley-neutral');
						$('#notation_smiley_survey_question_desk').attr('class', 'survey-step-2__floating-score-box-smiley notation-smiley-neutral');
						$('.your-score-progressbar .mdc-linear-progress__bar-inner').addClass('progress-bar-blue');
						$('.your-score-progressbar .your-score').addClass('color-blue');
					} else {
						$('#notation_smiley_survey_question_mob').attr('class', 'survey-step-2__floating-score-box-smiley notation-smiley-bad');
						$('#notation_smiley_survey_question_desk').attr('class', 'survey-step-2__floating-score-box-smiley notation-smiley-bad');
						$('.your-score-progressbar .mdc-linear-progress__bar-inner').addClass('progress-bar-red');
						$('.your-score-progressbar .your-score').addClass('color-red');
					}


					$('#satisfaction-question .survey-step-2__satisfaction-score').html(round(Rating / 10, 1));
					calculateSatisfactionRating(impression_good, impression_bad, round(Rating, 1));
				}
			}

			function calculateSatisfactionRating(impression_good, impression_bad, value) {

				$('#satisfaction-question .survey-step-2__satisfaction-score').html(round((value / 10), 1));
				$('.your-score').html(round((value / 10), 1));
				$('.your-score-progressbar .mdc-linear-progress__bar').data("value", value);
				$('.mdc-slider-satisfaction').removeClass(function (index, className) {
					return (className.match(/(^|\s)slider-\S+/g) || []).join(' ');
				});

				if (value < (impression_good) && value > (impression_bad)) {
					$('.mdc-slider-satisfaction').addClass('slider-blue');
				} else if (value < (impression_bad)) {
					$('.mdc-slider-satisfaction').addClass('slider-red');
				} else {
					$('.mdc-slider-satisfaction').addClass('slider-green');
				}

				$('.your-score-progressbar .mdc-linear-progress__bar-inner').removeClass(function (index, className) {
					return (className.match(/(^|\s)progress-bar-\S+/g) || []).join(' ');
				});

				$('.your-score-progressbar .your-score').removeClass(function (index, className) {
					return (className.match(/(^|\s)color-\S+/g) || []).join(' ');
				});

				if (value >= parseInt(impression_good)) {
					$('#notation_smiley_survey_question_mob').attr('class', 'survey-step-2__floating-score-box-smiley notation-smiley-good');
					$('#notation_smiley_survey_question_desk').attr('class', 'survey-step-2__floating-score-box-smiley notation-smiley-good');
					$('.your-score-progressbar .mdc-linear-progress__bar-inner').addClass('progress-bar-green');
					$('.your-score-progressbar .your-score').addClass('color-green');
				} else if (value >= parseInt(impression_bad)) {
					$('#notation_smiley_survey_question_mob').attr('class', 'survey-step-2__floating-score-box-smiley notation-smiley-neutral');
					$('#notation_smiley_survey_question_desk').attr('class', 'survey-step-2__floating-score-box-smiley notation-smiley-neutral');
					$('.your-score-progressbar .mdc-linear-progress__bar-inner').addClass('progress-bar-blue');
					$('.your-score-progressbar .your-score').addClass('color-blue');
				} else {
					$('#notation_smiley_survey_question_mob').attr('class', 'survey-step-2__floating-score-box-smiley notation-smiley-bad');
					$('#notation_smiley_survey_question_desk').attr('class', 'survey-step-2__floating-score-box-smiley notation-smiley-bad');
					$('.your-score-progressbar .mdc-linear-progress__bar-inner').addClass('progress-bar-red');
					$('.your-score-progressbar .your-score').addClass('color-red');
				}
				animateNotation('.your-score-progressbar');
			}

			function round(value, precision) {
				var multiplier = Math.pow(10, precision || 0);
				return Math.round(value * multiplier) / multiplier;
			}

			function cleanQueryParameter(value) {
				if (!value) {
					return value;
				}

				return value.split('?')[0].split('#')[0];
			}

			function setMobile() {
				$('.phone-widget-container .phone-widget input[type="text"]').attr('name', 'resend-phone');
				$('.phone-widget-container .phone-widget label').html(i18next.t('phone-widget:mobile_phone'));
				$('.phone-widget-container .phone-widget-btn').html(i18next.t('survey-step3:resend_text'));
				$('.phone-widget-container .phone-widget-btn').removeClass(function (index, className) {
					return (className.match(/(^|\s)survey-step-3\S+/g) || []).join(' ');
				});
				$('.phone-widget-container .phone-widget-btn').addClass('survey-step-3__resend-text-button');
			}

			function setLandPhone() {
				$('.phone-widget-container .phone-widget input[type="text"]').attr('name', 'validate_voice_number');
				$('.phone-widget-container .phone-widget label').html(i18next.t('phone-widget:telephone'));
				$('.phone-widget-container .phone-widget-btn').html(i18next.t('survey-step3:call_me_text'));
				$('.phone-widget-container .phone-widget-btn').removeClass(function (index, className) {
					return (className.match(/(^|\s)survey-step-3\S+/g) || []).join(' ');
				});
				$('.phone-widget-container .phone-widget-btn').addClass('survey-step-3__phone-call-me');
			}

		});
	});
});